import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Chat from "../pages/Chat";
import Clients from "../pages/Clients";
import ClientDetails from "../pages/Clients/ClientDetails";
import Pipeline from "../pages/Pipeline";
import SalePipeline from "../pages/SalesPipeline"; 
import Products from "../pages/Products";
import Surveys from "../pages/Surveys"; 
import SurveyAnalyticsPage from "../pages/Surveys/SurveyAnalyticsPage";
import Users from "../pages/Settings/Users";
import Channels from "../pages/Settings/Channels";
import Types from "../pages/Settings/Types";
import Companies from "../pages/Settings/Companies";
import AutomationRules from "../pages/Settings/AutomationRules";
import PaymentMethods from "../pages/Settings/PaymentMethods";
import DeliveryMethods from "../pages/Settings/DeliveryMethods";
import Integrations from "../pages/Settings/Integrations";
import UserDetails from "../pages/UserDetails";
import SearchResults from "../pages/SearchResults";
import Campaigns from "../pages/Campaigns";
import LoginPage from "../pages/LoginPage";
import SignupPage from "../pages/SignupPage";
import VerifyEmailPage from "../pages/VerifyEmailPage";
import PublicSurveyPage from "../pages/PublicSurveyPage";
import PublicWebsitePage from "../pages/PublicWebsitePage";
import ProfilePage from "../pages/ProfilePage";
import PrivateRoute from "../components/PrivateRoute";
import UserPlan from "../pages/UserPlan";
import BotFlowEditor from "../pages/Settings/Users/BotFlowEditor";
import CallPopup from "../pages/CallPopup";
import SetupPage from "../pages/SetupPage";
import Categories from "../pages/Categories";
import Coupons from "../pages/Coupons";
import PipelineStages from "../pages/PipelineStages";
import Banners from "../pages/Banners";
import Contents from "../pages/Contents";
import Positions from "../pages/Settings/Positions";
import AwarenessStages from "../pages/AwarenessStages";
import SetPassword from "../pages/SetPassword";
import AntifraudMethods from "../pages/Settings/AntifraudMethods";
import AgentsList from "../pages/Agents/AgentsList";
import AgentForm from "../pages/Agents/AgentForm";
import AgentAnalytics from "../pages/Agents/AgentAnalytics";
import ChatbotConfig from "../pages/Settings/ChatbotConfig";
import WorkspaceI18nSettings from "../pages/Settings/WorkspaceI18n";
import BillingSettingsPage from "../pages/Settings/Billing";
import PlatformXprobaseConsole from "../pages/Platform/XprobaseConsole";
import RequireMasterPlatform from "../components/auth/RequireMasterPlatform";

// >>> Guards por permissão (usa /me/permissions)
import Require from "../components/auth/Require";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Rota de login */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/public/surveys/:slug" element={<PublicSurveyPage />} />
      <Route path="/public/websites" element={<PublicWebsitePage />} />
      <Route path="/public/websites/:slug" element={<PublicWebsitePage />} />

      <Route path="/onboarding/password" element={<SetPassword />} />

      {/* Rotas sem layout */}
      <Route
        path="/popup-call/:id"
        element={
          <PrivateRoute noLayout>
            <CallPopup />
          </PrivateRoute>
        }
      />
      <Route path="/setup" element={<SetupPage />} />

      {/* Rotas protegidas (com layout) */}
      <Route path="/" element={<PrivateRoute />}>
        {/* Index → Chat */}
        <Route
          index
          element={
            <Require resource="chat" action="view">
              <Chat />
            </Require>
          }
        />

        {/* Páginas principais */}
        <Route
          path="chat"
          element={
            <Require resource="chat" action="view">
              <Chat />
            </Require>
          }
        />
        <Route
          path="chat/:id"
          element={
            <Require resource="chat" action="view">
              <Chat />
            </Require>
          }
        />
        <Route
          path="dashboard"
          element={
            <Require resource="dashboard" action="view">
              <Dashboard />
            </Require>
          }
        />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="user-plan" element={<UserPlan />} />
        <Route
          path="clients"
          element={
            <Require resource="clients" action="view">
              <Clients />
            </Require>
          }
        />
        <Route
          path="clients/:id"
          element={
            <Require resource="clients" action="view">
              <ClientDetails />
            </Require>
          }
        />
        <Route
          path="pipeline"
          element={
            <Require resource="awareness" action="view">
              <Pipeline />
            </Require>
          }
        />

        {/* >>> AQUI: duas rotas, com e sem ID */}
        <Route
          path="sales-pipeline"
          element={
            <Require resource="sales_pipeline" action="view">
              <SalePipeline />
            </Require>
          }
        />
        <Route
          path="sales-pipeline/:id"
          element={
            <Require resource="sales_pipeline" action="view">
              <SalePipeline />
            </Require>
          }
        />
        {/* <<< */}

        <Route
          path="products"
          element={
            <Require resource="products" action="view">
              <Products />
            </Require>
          }
        />
        <Route
          path="agents"
          element={
            <Require resource="agents" action="view">
              <AgentsList />
            </Require>
          }
        />
        <Route
          path="agents/new"
          element={
            <Require resource="agents" action="create">
              <AgentForm />
            </Require>
          }
        />
        <Route
          path="agents/:id"
          element={
            <Require resource="agents" action="view">
              <AgentForm />
            </Require>
          }
        />
        <Route
          path="agents/:id/analytics"
          element={
            <Require resource="agents" action="view">
              <AgentAnalytics />
            </Require>
          }
        />
        <Route
          path="surveys"
          element={
            <Require resource="surveys" action="view">
              <Surveys />
            </Require>
          }
        />
        <Route
          path="surveys/:id/analytics"
          element={
            <Require resource="surveys" action="view">
              <SurveyAnalyticsPage />
            </Require>
          }
        />
        <Route
          path="campaigns"
          element={
            <Require resource="campaigns" action="view">
              <Campaigns />
            </Require>
          }
        />
        <Route
          path="user-details/:userId"
          element={
            <Require resource="users" action="view">
              <UserDetails />
            </Require>
          }
        />
        <Route path="search-results" element={<SearchResults />} />

        {/* Configurações */}
        <Route
          path="settings/users"
          element={
            <Require resource="users" action="view">
              <Users />
            </Require>
          }
        />
        <Route
          path="settings/positions"
          element={
            <Require resource="positions" action="view">
              <Positions />
            </Require>
          }
        />
        <Route
          path="users/:id/bot"
          element={
            <Require resource="users" action="update">
              <BotFlowEditor />
            </Require>
          }
        />
        <Route
          path="settings/channels"
          element={
            <Require resource="channels" action="view">
              <Channels />
            </Require>
          }
        />
        <Route
          path="settings/types"
          element={
            <Require resource="types" action="view">
              <Types />
            </Require>
          }
        />
        <Route
          path="settings/companies"
          element={
            <Require resource="companies" action="view">
              <Companies />
            </Require>
          }
        />
        <Route
          path="settings/chatbot"
          element={
            <Require resource="chatbot" action="view">
              <ChatbotConfig />
            </Require>
          }
        />
        <Route
          path="settings/automation-rules"
          element={
            <Require resource="automation_rules" action="view">
              <AutomationRules />
            </Require>
          }
        />
        <Route
          path="settings/antifraud-methods"
          element={
            <Require resource="antifraud_methods" action="view">
              <AntifraudMethods />
            </Require>
          }
        />
        <Route
          path="settings/payment-methods"
          element={
            <Require resource="payment_methods" action="view">
              <PaymentMethods />
            </Require>
          }
        />
        <Route
          path="settings/billing"
          element={
            <Require resource="billing" action="view">
              <BillingSettingsPage />
            </Require>
          }
        />
        <Route
          path="platform/xprobase/*"
          element={
            <RequireMasterPlatform>
              <PlatformXprobaseConsole />
            </RequireMasterPlatform>
          }
        />
        <Route
          path="settings/delivery-methods"
          element={
            <Require resource="delivery_methods" action="view">
              <DeliveryMethods />
            </Require>
          }
        />
        <Route
          path="settings/integrations"
          element={
            <Require resource="integrations" action="view">
              <Integrations />
            </Require>
          }
        />
        <Route
          path="settings/workspace-language"
          element={
            <Require resource="workspace_i18n" action="view">
              <WorkspaceI18nSettings />
            </Require>
          }
        />

        {/* Catálogos adicionais */}
        <Route
          path="categories"
          element={
            <Require resource="categories" action="view">
              <Categories />
            </Require>
          }
        />
        <Route
          path="coupons"
          element={
            <Require resource="coupons" action="view">
              <Coupons />
            </Require>
          }
        />
        <Route
          path="banners"
          element={
            <Require resource="banners" action="view">
              <Banners />
            </Require>
          }
        />
        <Route
          path="contents"
          element={
            <Require resource="contents" action="view">
              <Contents />
            </Require>
          }
        />

        {/* Etapas (duas telas) */}
        <Route
          path="pipeline-stages"
          element={
            <Require resource="pipeline_stages" action="view">
              <PipelineStages />
            </Require>
          }
        />
        <Route
          path="awareness-stages"
          element={
            <Require resource="awareness_stages" action="view">
              <AwarenessStages />
            </Require>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
